import axios from 'axios';
import { CURRENT_API_URL } from "../../../../Utils/Constants";
import notify from '../../../../Notifications/ToastifyActions';

function AddUserService(token, data) {
    return axios.post(`${CURRENT_API_URL}/account/addUser`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("User added successfully!");
        return res.data;
    
    }).catch(error => {
        const errorMessage = (error.response && error.response.data && error.response.data.error) 
                          || "Something went wrong while trying to add user.";
        notify.NotifyError(errorMessage);
        return false;
    });
}

export default AddUserService;
